import type { Bonus } from '../types/content';

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'The Hair Restoration Clinical Casebook',
    tagline: 'Educational Cases for Structured Professional Review',
    description: [
      'Explore hypothetical hair restoration cases organized around patient information, observed characteristics, assessment considerations, and questions for professional discussion.',
      'Instead of reviewing isolated facts, you can examine different educational scenarios through a structured framework.',
    ],
    inside: [
      'Hypothetical patient case summaries.',
      'Hair loss pattern observation worksheets.',
      'Donor characteristic review sheets.',
      'Hairline design discussion scenarios.',
      'Structured case analysis questions.',
      'Educational review templates.',
    ],
    value: 19,
    image: 'https://cdn.magicpatterns.com/uploads/a7pmEW3Kx4nHnWnrS55Cta/BONUS_1_TRANPLSNT-EN.png',
  },
  {
    number: 2,
    title: 'The Hair Transplant Patient Assessment Toolkit',
    tagline: 'Organize Patient Assessment Information in One Place',
    description: [
      'This toolkit brings together educational forms and worksheets designed to help organize relevant patient information during professional assessment.',
    ],
    inside: [
      'Patient information worksheet.',
      'Hair loss history review form.',
      'Scalp observation checklist.',
      'Patient expectation documentation sheet.',
      'Donor area observation worksheet.',
      'Consultation preparation checklist.',
    ],
    note: 'Adapt all materials to your professional scope and applicable requirements.',
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/k3ueFGTyhw2qowNfd5rqZr/BONUS_2_TRANSPLANT-EN.png',
  },
  {
    number: 3,
    title: 'The Hairline Design Visual Reference Atlas',
    tagline: 'A Visual Resource for Studying Hairline Design Concepts',
    description: [
      'Study different educational examples of hairline configurations, facial proportions, and aesthetic considerations in hair restoration.',
    ],
    inside: [
      'Hairline design reference illustrations.',
      'Facial proportion study sheets.',
      'Natural hairline variation references.',
      'Hair growth direction illustrations.',
      'Comparative educational examples.',
      'Hairline discussion worksheets.',
    ],
    note: 'The atlas supports educational study and does not prescribe individualized surgical plans.',
    value: 19,
    image: 'https://cdn.magicpatterns.com/uploads/n9qS7wRGEopxq1yLNDVuFz/BONUS_3_TRANSPLANT-EN.png',
  },
  {
    number: 4,
    title: 'The Hair Transplant Follow-Up Documentation Toolkit',
    tagline: 'Organize Photographic Records and Follow-Up Information',
    description: [
      'Bring relevant documentation resources together with templates for organizing patient progress, photographic records, and follow-up observations.',
    ],
    inside: [
      'Follow-up record templates.',
      'Photographic documentation checklists.',
      'Hair restoration progress record sheets.',
      'Patient communication documentation examples.',
      'Follow-up observation worksheets.',
      'Adverse-event documentation forms.',
    ],
    note: 'All materials should be reviewed and adapted to applicable professional and privacy requirements.',
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/dbvCtg1hxJBXYrv2kbKSP8/BONUS_4_TRANSPLANT-EN.png',
  },
  {
    number: 5,
    title: 'The Hair Restoration Practice Organization Workbook',
    tagline: 'Review the Organization of Your Professional Resources',
    description: [
      'This workbook provides a structured format for reviewing documentation practices, educational resources, photographic records, and follow-up processes within a professional setting.',
    ],
    inside: [
      'Professional resource organization checklist.',
      'Documentation workflow review sheets.',
      'Patient record organization worksheets.',
      'Photographic record review checklist.',
      'Follow-up process assessment.',
      'Professional improvement planning worksheets.',
    ],
    note: 'This workbook supports internal organization. It does not certify compliance or replace applicable professional standards.',
    value: 19,
    image: 'https://cdn.magicpatterns.com/uploads/k1DtL6B7cup9U7v4w7Ax2B/BONUS_5_TRANSPLANT-EN.png',
  },
];
